var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagMexico(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mexico",
    clipPath: "url(#clip0_0_42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24 12C24 7.24247 21.2313 3.13172 17.2174 1.19072V22.8092C21.2313 20.8683 24 16.7575 24 12V12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 12C0 16.7575 2.76867 20.8683 6.78262 22.8093V1.19072C2.76867 3.13172 0 7.24247 0 12Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.86955 12C8.86955 13.7289 10.2711 15.1305 12 15.1305C13.7289 15.1305 15.1305 13.7289 15.1305 12V10.9565H8.86955V12Z",
    fill: "#6DA544"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.1739 9.91303H13.0434C13.0434 9.33675 12.5762 8.86955 12 8.86955C11.4237 8.86955 10.9565 9.33675 10.9565 9.91303H7.82602C7.82602 10.4894 8.328 10.9565 8.90423 10.9565H8.8695C8.8695 11.5328 9.33666 12 9.91298 12C9.91298 12.5763 10.3801 13.0435 10.9565 13.0435H13.0434C13.6198 13.0435 14.0869 12.5763 14.0869 12C14.6632 12 15.1304 11.5328 15.1304 10.9565H15.0956C15.672 10.9565 16.1739 10.4894 16.1739 9.91303Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMexico);
export default __webpack_public_path__ + "static/media/flag-mexico.ec68c2d5ee2957aa60317c7dabe342d0.svg";
export { ForwardRef as ReactComponent };